import { FeatureFlippingEntry } from "@hermes/feature-flipping";

export enum PersoFeatureFlippingKey {
    /* eslint-disable @typescript-eslint/naming-convention */
    pm_key = "smallleathergoods_personalization",
    beltkit_key = "beltkits_personalization",
    /* eslint-enable @typescript-eslint/naming-convention */
}

// Catalog feature flag constants
export const PERFUME_ENGRAVING = "perfume_engraving";
export const ENABLE_JEWEL_FINISH_SELECTOR = "enable_jewel_finish_selector";
export const ENABLE_BELTKIT_FINISH_SELECTOR = "pdp_beltkit_finish_selector";
export const ENABLE_INP_PATCH_SPA = "enable_inp_patch_spa";
export const PRODUCT_PAGE_DISPLAY_ONLY = "pure_display_only";
export const PRODUCT_PAGE_USERGUIDE = "product_page_userguide";
export const ENABLE_PLP_PUSH_ICONIC = "enable_plp_pushiconic";
export const ENABLE_QUICK_BUY_REVAMP = "enable_quick_buy_revamp";
export const ROLLOUT_MEA = "rollout_mea";
export const ENABLE_PLP_STOPBOUNCING = "enable_plp_stopbouncing";
export const ENABLE_PLP_TEXT_ANIMATION = "enable_plp_tag_text_animation";
export const ENABLE_PLP_STEPPER = "enable_plp_stepper";
export const PLP_REDESIGN = "plp_redesign";
export const ENABLE_PLP_ERROR_PAGE = "enable_plp_error_page";
export const ENABLE_F34_IMAGE = "enable_f34";
export const NEWSEARCHTOOL_PRODUCT_TRACKING = "newsearchtool_product_tracking";

// Page feature flag constants
export const ENABLE_PDP_REDESIGN_SIMPLE = "enable_product_page_redesign_simple";
export const ENABLE_PDP_REDESIGN_BELTKIT =
    "enable_product_page_redesign_belkit";
export const ENABLE_PDP_REDESIGN_APPLE_WATCH =
    "enable_product_page_redesign_apple_watch";
export const ENABLE_PDP_REDESIGN_DOUBLE_FRAGRANCE =
    "enable_product_page_redesign_double_fragrance";
export const ENABLE_PDP_REDESIGN_BIKINI = "enable_product_page_redesign_bikini";
export const ENABLE_PDP_REDESIGN_BUNDLE = "enable_product_page_redesign_bundle";
export const ENABLE_PDP_REDESIGN_GIFT_SET =
    "enable_product_page_redesign_gift_set";
export const ENABLE_PDP_REDESIGN_LOOK = "enable_product_page_redesign_look";
export const ENABLE_PDP_REDESIGN_DISPLAY_ONLY =
    "enable_product_page_redesign_display_only";
export const ENABLE_PDP_REDESIGN_PERSO = "enable_product_page_redesign_perso";
export const ENABLE_PRODUCT_PAGE_REFACTO_AND_REDESIGN_FORM_CONTROL =
    "enable_product_page_refacto_and_redesign_form_control";
export const ENABLE_PRODUCT_PAGE_REFACTO_AND_PRIMARY_SIZE_SELECTOR =
    "enable_product_page_refacto_and_primary_size_selector";
export const ENABLE_VIDEOJS_REDESIGN = "enable_videojs_redesign";
export const ENABLE_LAST_VIEWED_PRODUCTS = "enable_last_viewed_products";
export const ENABLE_PDP_DISCOVER_MORE_BLOC = "enable_pdp_discover_more_bloc";
export const ENABLE_PDP_CONTACT_AN_EXPERT_CTA =
    "enable_pdp_contact_an_expert_cta";
export const ENABLE_PDP_DESIGNERS_ATTRIBUTE = "enable_pdp_designers_attribute";
export const ENABLE_METAL_FINISH_DESCRIPTION =
    "enable_metal_finish_description";
export const ENABLE_STORY_BEHIND_MULTIPLE_MEDIA_BLOC =
    "enable_story_behind_multiple_media_bloc";
export const ENABLE_PRODUCT_PAGE_STORY_BEHIND_PUSH_MERCH =
    "enable_product_page_story_behind_push_merch";
export const ENABLE_PRODUCT_PAGE_DISPLAY_SELECTOR_PRODUCT_TAG =
    "enable_product_page_display_selector_product_tag";
export const ENABLE_QUICK_BUY_ON_PDP_CROSS_SELL =
    "enable_quick_buy_on_pdp_cross_sell";

// Cart feature flag constants
export const ENABLE_CART_REDESIGN = "enable_cart_redesign";

// Checkout feature flag constants
export const ENABLE_LIVECHAT_V2 = "enable_livechat_v2";
export const ENABLE_SAMPLE_BLOCK_INTO_CART = "enable_sample_block_into_cart";

export const ACCOUNT_PAGE_ANGULAR_V2 = "account_page_angular_v2";
export const EDIT_PHONE_WITH_OTP = "edit_phone_with_otp";
export const COMMUNICATION_CONSENT_ACTIVATION = "communication_consent";
export const ENABLE_OPTIN_COMMUNICATION = "enable_optin_communication";

export const ENABLE_EMAIL_VERIFICATION = "enable_email_verification";

export const ENABLE_HIDING_PROFILE_INFORMATION =
    "enable_hiding_profile_information";

export const ENABLE_NEUTRAL_GENDER = "enable_neutral_gender";

// Return feature flag constants
export const ENABLE_NEW_RETURN_REASON = "return__enable_new_return_reasons";
export const ENABLE_RETURN_PARTIAL_BUNDLE =
    "return__enable_return_partial_bundle";

// Payment feature flag constants
export const RISKIFIED_BEACON = "riskified_beacon";
export const USE_QR_CODE_PAYMENT_MODAL = "use_qr_code_payment_modal";
export const USE_CHECKOUT_COM_FLOW = "use_checkout_com_flow";
export const USE_PAYMENT_FOR_PAYMENT_METHOD_RULES =
    "use_payment_for_payment_method_rules";
export const PREFILL_CARD_HOLDER_NAME = "prefill_card_holder_name";
export const ENABLE_ADYEN_WEB_V6 = "enable_adyen_web_v6";
export const ENABLE_LPM_REASSURANCE_MESSAGES =
    "enable_lpm_reassurance_messages";

export const ANGULAR_SPA_ACTIVATION_ON_PERSO_GENERIC_CONFIGURATOR =
    "angular_spa_activation_on_perso_generic_configurator";

// PL/E-resa feature flag constants
export const PRODUCT_LOCATOR_ACTIVATION = "product_locator";
export const ERESERVATION_ACTIVATION = "ereservation";
export const ERESERVATION_CANCEL = "ereservation_cancel";
export const PRODUCT_LOCATOR_DISPLAY_MAP_MOBILE_ACTIVATION =
    "product_locator_display_map_mobile";

// Display Only
export const PRODUCT_DISPLAY_ONLY = "product_display_only";
export const PRODUCT_BACK_IN_STOCK = "product_back_in_stock";
export const PRODUCT_REGISTER_YOUR_INTEREST = "product_register_your_interest";

// Aftersales feature flag constants
export const AFTERSALES_FIND_A_SHOP_ACTIVATION = "aftersales_find_a_store";
export const AFTERSALES_CONSULT = "aftersales_consult";

// Appointment in store flag constants
export const APPOINTMENT_IN_STORE = "appointment_in_store";
export const APPOINTMENT_IN_STORE_AFTERSALES =
    "appointment_in_store_aftersales";

export const REMOVE_PRICELESS_INVOICE_CHECKBOX =
    "remove_priceless_invoice_checkbox";

// Perfumes and Beauty feature flag constants
export const ANGULAR_SPA_ACTIVATION_ON_MENU_STORY_LINK =
    "angular_spa_activation_on_menu_story_link";
export const ANGULAR_AGEC_DISPLAY_TITLE = "angular_agec_page_title";

export const ADDITIONAL_STREET_ADDRESS = "additional_street_address";

export const AGEC_DANGEROUS_SUBSTANCE_DESCRIPTION =
    "agec_dangerous_substance_description";

export const ANGULAR_AGEC_NEW_FORMAT_PACKAGING = "agec_new_format_packaging";

export const AUTHORIZATION_TO_AGEC_PAGE = "authorization_to_agec_page";

export const FOOTER_NEWSLETTER_REMOVAL = "remove_footer_newsletter_block";

export const ENABLE_MORE_SHIPPING_INFO = "enable_more_shipping_info";
export const LEAD_TIME_FROM_INVENTORY = "lead_time_from_inventory";
export const ENABLE_CFDI_BLOCK_IN_CHECKOUT = "enable_cfdi_block_in_checkout";

export const ENABLE_FRAGRANCE_FINDER_PAGE = "fragrance_finder_page";
export const ERESERVATION_ACCOUNT_ACTIVATION = "ereservation_on_account_page";

export const ENABLE_NEW_NOTIFICATION_BANNER = "enable_new_notification_banner";

export const ENABLE_NEW_GEOFILTERING_TRAY = "enable_new_geofiltering_tray";

export const ENABLE_BREADCRUMB_LVL1_CLICKABLE =
    "enable_breadcrumb_lvl1_clickable";

export const ENABLE_SHADE_FINDER = "enable_shade_finder";
export const ENABLE_ONETRUST_COOKIE_CENTER_RELOAD =
    "enable_onetrust_cookie_center_reload";
export const ENABLE_DELIVERY_SPECIAL_REQUEST =
    "enable_delivery_special_request";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const RESET_PWD_ANGULAR = "reset_pwd_angular";

export const ENABLE_BUNDLE_PRODUCT_COMPONENT =
    "enable_bundle_product_component";

export const ACTIVATE_301_REDIRECT_FOR_SKU_WITH_SIZE =
    "activate_301_redirect_for_sku_with_size";

export const ENABLE_CONSENT_CONTACT_NEWSLETTER_FORMS =
    "enable_consent_contact_newsletter_forms";

export const HEADER_FULL_TRANSPARENT = "header_full_transparent";
export const ENABLE_REDESIGN_HOMEPAGE = "redesign_homepage";
export const ENABLE_REDESIGN_EDITO_BLOCKS = "redesign_edito_blocks";

export const ENABLE_FULL_IMMERSIVE_VTO = "full_immersive_vto";
export const ENABLE_VTO_LOOKS = "vto_beauty_look";
export const ENABLE_REDESIGN_FRAGRANCE_FINDER_PAGE =
    "redesign_fragrance_finder_page";

// User guides
export const USER_GUIDES_ROUTE = "userguide_route";

// Safire
export const ENABLE_SAFIRE_WORKFLOW = "enable_safire_workflow";

export const SENSORS_DATA = "SENSORS_DATA";

export const FEATURE_ORANGE_BOX_STATIC = "feature_orange_box_static";

export const REDESIGN_FOOTER = "redesign_footer";

export const GRID_REMOVE_URL_FRAGMENT = "grid_remove_url_fragment";
export const STOCK_HELPERS_REFACTO = "stock_helpers_refacto";

export const CROSS_SELL_USE_PUBLIC_ENDPOINT = "cross_sell_use_public_endpoint";

// Technical Feature Flags constants
export const ENABLE_HCOM_GATEWAY = "enable_hcom_gateway";

export const ENABLE_REMOTE_RENDEZ_VOUS_ACCOUNT_SUBMENU =
    "enable_remote_rendez_vous_account_submenu";

export const ENABLE_BAMBUSER_PRODUCTION = "enable_bambuser_production";

export const ENABLE_NEW_CIVILITY = "use_new_customer_civilities";

export const ENABLE_CART_SAGAWA_NO_PREF_DROPDOWN_OPTION =
    "enable_cart_sagawa_no_pref_dropdown_option";
/**
 * add your feature flag "flagName" and "defaultValue" value
 *
 * /!\ this list is used only by when the APP_INIT dispatch FetchFeatureFlags action /!\
 */
export const FEATURE_FLAGS = [
    {
        flagName: PersoFeatureFlippingKey.beltkit_key,
        defaultValue: true,
    },
    {
        flagName: PersoFeatureFlippingKey.pm_key,
        defaultValue: true,
    },
    {
        flagName: ANGULAR_SPA_ACTIVATION_ON_PERSO_GENERIC_CONFIGURATOR,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_LOCATOR_DISPLAY_MAP_MOBILE_ACTIVATION,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_LOCATOR_ACTIVATION,
        defaultValue: true,
    },
    {
        flagName: ERESERVATION_ACTIVATION,
        defaultValue: true,
    },
    {
        flagName: ERESERVATION_ACCOUNT_ACTIVATION,
        defaultValue: false,
    },
    {
        flagName: ERESERVATION_CANCEL,
        defaultValue: false,
    },
    {
        flagName: ENABLE_LIVECHAT_V2,
        defaultValue: false,
    },
    {
        flagName: ENABLE_NEUTRAL_GENDER,
        defaultValue: false,
    },
    {
        flagName: AFTERSALES_FIND_A_SHOP_ACTIVATION,
        defaultValue: false,
    },
    {
        flagName: AFTERSALES_CONSULT,
        defaultValue: false,
    },
    {
        flagName: APPOINTMENT_IN_STORE,
        defaultValue: false,
    },
    {
        flagName: APPOINTMENT_IN_STORE_AFTERSALES,
        defaultValue: false,
    },
    {
        flagName: RISKIFIED_BEACON,
        defaultValue: false,
    },
    {
        flagName: ENABLE_SAMPLE_BLOCK_INTO_CART,
        defaultValue: true,
    },
    {
        flagName: COMMUNICATION_CONSENT_ACTIVATION,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_DISPLAY_ONLY,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_BACK_IN_STOCK,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_REGISTER_YOUR_INTEREST,
        defaultValue: false,
    },
    {
        flagName: REMOVE_PRICELESS_INVOICE_CHECKBOX,
        defaultValue: false,
    },
    {
        flagName: ANGULAR_SPA_ACTIVATION_ON_MENU_STORY_LINK,
        defaultValue: false,
    },
    {
        flagName: ADDITIONAL_STREET_ADDRESS,
        defaultValue: false,
    },
    {
        flagName: ANGULAR_AGEC_DISPLAY_TITLE,
        defaultValue: false,
    },
    {
        flagName: AUTHORIZATION_TO_AGEC_PAGE,
        defaultValue: false,
    },
    {
        flagName: ACCOUNT_PAGE_ANGULAR_V2,
        defaultValue: false,
    },
    {
        flagName: EDIT_PHONE_WITH_OTP,
        defaultValue: false,
    },
    {
        flagName: PERFUME_ENGRAVING,
        defaultValue: false,
    },
    {
        flagName: AGEC_DANGEROUS_SUBSTANCE_DESCRIPTION,
        defaultValue: false,
    },
    {
        flagName: ANGULAR_AGEC_NEW_FORMAT_PACKAGING,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_PAGE_USERGUIDE,
        defaultValue: false,
    },
    { flagName: ENABLE_PLP_STOPBOUNCING, defaultValue: false },
    {
        flagName: ENABLE_PLP_TEXT_ANIMATION,
        defaultValue: false,
    },
    {
        flagName: ENABLE_QUICK_BUY_REVAMP,
        defaultValue: false,
    },
    {
        flagName: PRODUCT_PAGE_DISPLAY_ONLY,
        defaultValue: false,
    },
    { flagName: ENABLE_PLP_STEPPER, defaultValue: false },
    { flagName: PLP_REDESIGN, defaultValue: false },
    {
        flagName: ENABLE_PLP_ERROR_PAGE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_F34_IMAGE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PLP_PUSH_ICONIC,
        defaultValue: false,
    },
    {
        flagName: FOOTER_NEWSLETTER_REMOVAL,
        defaultValue: false,
    },
    {
        flagName: ENABLE_MORE_SHIPPING_INFO,
        defaultValue: false,
    },
    {
        flagName: LEAD_TIME_FROM_INVENTORY,
        defaultValue: false,
    },
    {
        flagName: ENABLE_CONSENT_CONTACT_NEWSLETTER_FORMS,
        defaultValue: false,
    },
    {
        flagName: ENABLE_CFDI_BLOCK_IN_CHECKOUT,
        defaultValue: false,
    },
    {
        flagName: ENABLE_FRAGRANCE_FINDER_PAGE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_NEW_NOTIFICATION_BANNER,
        defaultValue: false,
    },
    {
        flagName: ENABLE_NEW_GEOFILTERING_TRAY,
        defaultValue: false,
    },
    {
        flagName: ENABLE_OPTIN_COMMUNICATION,
        defaultValue: false,
    },
    {
        flagName: ENABLE_BREADCRUMB_LVL1_CLICKABLE,
        defaultValue: false,
    },
    {
        flagName: USE_QR_CODE_PAYMENT_MODAL,
        defaultValue: true,
    },
    {
        flagName: PREFILL_CARD_HOLDER_NAME,
        defaultValue: true,
    },
    {
        flagName: ENABLE_ADYEN_WEB_V6,
        defaultValue: false,
    },
    {
        flagName: ENABLE_LPM_REASSURANCE_MESSAGES,
        defaultValue: false,
    },
    {
        flagName: USE_CHECKOUT_COM_FLOW,
        defaultValue: true,
    },
    {
        flagName: USE_PAYMENT_FOR_PAYMENT_METHOD_RULES,
        defaultValue: false,
    },
    {
        flagName: ENABLE_EMAIL_VERIFICATION,
        defaultValue: false,
    },
    {
        flagName: ENABLE_SHADE_FINDER,
        defaultValue: false,
    },
    {
        flagName: ENABLE_DELIVERY_SPECIAL_REQUEST,
        defaultValue: false,
    },
    {
        flagName: ENABLE_ONETRUST_COOKIE_CENTER_RELOAD,
        defaultValue: false,
    },
    {
        flagName: RESET_PWD_ANGULAR,
        defaultValue: false,
    },
    {
        flagName: ENABLE_BUNDLE_PRODUCT_COMPONENT,
        defaultValue: false,
    },
    {
        flagName: ACTIVATE_301_REDIRECT_FOR_SKU_WITH_SIZE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_JEWEL_FINISH_SELECTOR,
        defaultValue: false,
    },
    {
        flagName: ENABLE_BELTKIT_FINISH_SELECTOR,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_SIMPLE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_BELTKIT,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_APPLE_WATCH,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_DOUBLE_FRAGRANCE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_BIKINI,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_BUNDLE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_GIFT_SET,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_LOOK,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_DISPLAY_ONLY,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_REDESIGN_PERSO,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PRODUCT_PAGE_REFACTO_AND_REDESIGN_FORM_CONTROL,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PRODUCT_PAGE_REFACTO_AND_PRIMARY_SIZE_SELECTOR,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PDP_DESIGNERS_ATTRIBUTE,
        defaultValue: false,
    },
    {
        flagName: ENABLE_VIDEOJS_REDESIGN,
        defaultValue: false,
    },
    {
        flagName: HEADER_FULL_TRANSPARENT,
        defaultValue: false,
    },
    {
        flagName: USER_GUIDES_ROUTE,
        defaultValue: false,
    },
    {
        flagName: STOCK_HELPERS_REFACTO,
        defaultValue: true,
    },
    {
        flagName: ENABLE_SAFIRE_WORKFLOW,
        defaultValue: false,
    },
    {
        flagName: SENSORS_DATA,
        defaultValue: false,
    },
    { flagName: ENABLE_LAST_VIEWED_PRODUCTS, defaultValue: false },
    { flagName: ENABLE_PDP_DISCOVER_MORE_BLOC, defaultValue: false },
    { flagName: ENABLE_PDP_CONTACT_AN_EXPERT_CTA, defaultValue: false },
    {
        flagName: ENABLE_REDESIGN_HOMEPAGE,
        defaultValue: false,
    },
    {
        flagName: GRID_REMOVE_URL_FRAGMENT,
        defaultValue: false,
    },
    {
        flagName: ENABLE_REDESIGN_EDITO_BLOCKS,
        defaultValue: false,
    },
    { flagName: FEATURE_ORANGE_BOX_STATIC, defaultValue: false },
    { flagName: ENABLE_CART_REDESIGN, defaultValue: false },
    { flagName: ENABLE_HIDING_PROFILE_INFORMATION, defaultValue: false },
    {
        flagName: REDESIGN_FOOTER,
        defaultValue: false,
    },
    { flagName: ENABLE_INP_PATCH_SPA, defaultValue: false },
    { flagName: ROLLOUT_MEA, defaultValue: false },
    { flagName: ENABLE_REDESIGN_EDITO_BLOCKS, defaultValue: false },
    { flagName: ENABLE_NEW_RETURN_REASON, defaultValue: false },
    { flagName: NEWSEARCHTOOL_PRODUCT_TRACKING, defaultValue: false },
    { flagName: CROSS_SELL_USE_PUBLIC_ENDPOINT, defaultValue: false },
    { flagName: ENABLE_HCOM_GATEWAY, defaultValue: false },
    { flagName: ENABLE_METAL_FINISH_DESCRIPTION, defaultValue: false },
    { flagName: ENABLE_STORY_BEHIND_MULTIPLE_MEDIA_BLOC, defaultValue: false },
    {
        flagName: ENABLE_REMOTE_RENDEZ_VOUS_ACCOUNT_SUBMENU,
        defaultValue: false,
    },
    {
        flagName: ENABLE_BAMBUSER_PRODUCTION,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PRODUCT_PAGE_STORY_BEHIND_PUSH_MERCH,
        defaultValue: false,
    },
    {
        flagName: ENABLE_PRODUCT_PAGE_DISPLAY_SELECTOR_PRODUCT_TAG,
        defaultValue: false,
    },
    {
        flagName: ENABLE_QUICK_BUY_ON_PDP_CROSS_SELL,
        defaultValue: false,
    },
    { flagName: ENABLE_NEW_CIVILITY, defaultValue: false },
    { flagName: ENABLE_FULL_IMMERSIVE_VTO, defaultValue: false },
    { flagName: ENABLE_VTO_LOOKS, defaultValue: false },
    { flagName: ENABLE_RETURN_PARTIAL_BUNDLE, defaultValue: false },
    { flagName: ENABLE_REDESIGN_FRAGRANCE_FINDER_PAGE, defaultValue: false },
    {
        flagName: ENABLE_CART_SAGAWA_NO_PREF_DROPDOWN_OPTION,
        defaultValue: false,
    },
] as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[number]["flagName"];

export type FeatureFlagDefinition = FeatureFlippingEntry & {
    flagName: FeatureFlagName;
};
